import React from "react";
import classNames from "classnames";

const ModalAction = props => {
  const { onAccept, onReject, header, disabled = false, disabledAccept = false } = props;
  const klass = classNames("action-modal", "action-modal__modal", {
    "action-modal__disabled": disabled
  });

  const klassAccept = classNames("btn", "btn-primary", {
    "disabled": disabledAccept
  })

  return (
    <div className={klass}>
      <div className="action-modal__bg"></div>
      <div className="action-modal__body">
        {header && <div className="action-modal__header">{props.header}</div>}
        <div className="action-modal__content">
          {props.children || props.description}
        </div>
        <div className="action-modal__actions">
          <button className="btn btn-form" onClick={onReject}>
            {props.textReject || i18n.t('decline')}
          </button>
          <button className={klassAccept} onClick={onAccept} disabled={disabledAccept}>
            {props.textAccept || i18n.t('accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalAction;
